module.exports = __webpack_public_path__ + "static/media/PU.4fc0ee1a.svg";